export const PRINTER = 'Printer';
/** Builds the deterministic printer document id. */
export function buildPrinterId(agentId, printerName) {
    return `${agentId}__${printerName}`;
}
//# sourceMappingURL=printer.js.map